module.exports = __webpack_public_path__ + "img/fi-roundup-600x395.e8501f7f.jpg";